import { CanonicalizeError } from '@/errors'

/**
 * Canonicalize a JavaScript number per RFC 8785 section 3.2.2.3.
 * The spec cites ECMAScript Number.prototype.toString as the source of truth
 * for the output form. This function delegates to it for any finite value.
 * NaN, positive Infinity, and negative Infinity all throw because the spec
 * forbids them.
 */
export function canonicalizeNumber(value: number, path: readonly string[]): string {
  if (!Number.isFinite(value)) {
    throw new CanonicalizeError(
      'NON_FINITE_NUMBER',
      `Non-finite number (${value}) is not representable in canonical JSON`,
      path
    )
  }
  // Both positive zero and negative zero canonicalize to the literal "0".
  if (value === 0) {
    return '0'
  }
  return value.toString()
}
